/* RUIXEIN product page behaviour: gallery, quantity, pack picker, variant price, sticky add-to-cart. */
(function () {
  document.querySelectorAll('[data-rx-product]').forEach(function (root) {
    var main = root.querySelector('.rx-main-img');
    root.querySelectorAll('.rx-thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.rx-thumbs button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (!main) return;
        if (btn.dataset.src) {
          main.removeAttribute('srcset');
          main.src = btn.dataset.src;
          main.style.transform = '';
        } else if (btn.dataset.z) {
          main.style.transformOrigin = btn.dataset.o;
          main.style.transform = 'scale(' + btn.dataset.z + ')';
        }
      });
    });

    var qty = root.querySelector('input[name="quantity"]');
    function setQty(n) { if (qty) qty.value = Math.max(1, parseInt(n, 10) || 1); }
    var dec = root.querySelector('[data-rx-dec]');
    var inc = root.querySelector('[data-rx-inc]');
    if (dec) dec.addEventListener('click', function () { setQty((+qty.value || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { setQty((+qty.value || 1) + 1); });
    root.querySelectorAll('input[name="rx-pack"]').forEach(function (r) {
      r.addEventListener('change', function () { setQty(r.value); });
    });

    var select = root.querySelector('select[name="id"]');
    var price = root.querySelector('[data-rx-price]');
    if (select && price) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
      });
    }

    var form = root.querySelector('form.rx-form');
    var sticky = root.querySelector('[data-rx-sticky]');
    var stickyBtn = root.querySelector('[data-rx-sticky-add]');
    var buyRow = root.querySelector('.rx-buy-row');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buyRow);
    }
  });
})();

/* Video testimonials + carousels (landing and product pages) */
(function () {
  document.querySelectorAll('.rx-video').forEach(function (card) {
    var video = card.querySelector('video');
    if (!video) return;
    function toggle() {
      document.querySelectorAll('.rx-video video').forEach(function (other) {
        if (other !== video) { other.pause(); other.closest('.rx-video').classList.remove('is-playing'); }
      });
      if (video.paused) { video.controls = true; video.play(); card.classList.add('is-playing'); }
      else { video.pause(); card.classList.remove('is-playing'); }
    }
    card.addEventListener('click', function (e) { if (e.target === video && card.classList.contains('is-playing')) return; toggle(); });
    card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });
  document.querySelectorAll('[data-rx-scroll]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.getElementById(btn.dataset.rxScroll);
      if (el) el.scrollBy({ left: (+btn.dataset.dir) * el.clientWidth * 0.8, behavior: 'smooth' });
    });
  });
})();

/* Floating product background: each bag drifts at its own speed, wraps around, and tilts toward the pointer. */
(function () {
  var items = [].slice.call(document.querySelectorAll('.rx-bgfx img'));
  if (!items.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mx = 0, my = 0, ticking = false;
  function frame() {
    ticking = false;
    var y = window.scrollY || 0, vh = window.innerHeight;
    items.forEach(function (el) {
      var s = +el.dataset.s, d = +el.dataset.d, h = el.offsetHeight || 300, span = vh + h * 2;
      var base = parseFloat(el.style.getPropertyValue('--y')) / 100 * vh;
      var t = ((base - y * s + h) % span + span) % span - h;
      var r = (+el.dataset.r) + y * s * 0.015 + mx * d * 0.08;
      el.style.transform = 'translate3d(' + (mx * d).toFixed(1) + 'px,' + (t + my * d).toFixed(1) + 'px,0) rotate(' + r.toFixed(2) + 'deg)';
    });
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  if (!reduce) {
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; req(); }, { passive: true });
  }
  window.addEventListener('resize', req);
  items.forEach(function (el) { el.addEventListener('load', req); });
  frame();
})();
